module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QYXX8N/tc-custom/9781440501951.jpg?1730489334859",
      "alt": "This image is the cover for the book Pregnancy Sucks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pregnancy Sucks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Pregnancy Sucks")]), _vm._v(", by Joanne Kimes and Sanford A. Tisherman, M.D., gives you real solutions to all the annoying and somewhat awkward situations that can unexpectedly arise during your pregnancy."), _c('br'), _vm._v("Did you know that:Farm-fresh butter, or petroleum jelly, works just as well for your itchy belly as a fancy and overpriced \"pregnancy\" product?If you're put on bedrest, walkie-talkies will allow you to yell at your husband-no matter where he is in the house!Surrounding yourself with regular pillows (don't forget to swipe your husband's) is just as good as buying a special large \"pregnancy pillow\"-and more adaptable to giving support where you personally need it?Doing the hokey pokey, or taking a warm shower, can ease Braxton Hicks contractions?"), _c('br'), _vm._v("Full of insight, hilarity, and practical solutions on every page, Pregnancy Sucks shows how, through it all, you can survive with your health, dignity, and sanity intact!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joanne Kimes, Sanford A. Tisherman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An Adams Media author.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0